import { gspx } from '@rsos/gainsight';
import getGeocoderName from '@rsos/utils/getGeocoderName';

/**
 * Tracks the reverse geocoding service provider name used for a location.
 * @param {String} irpVersion - IRP version
 * @param {String} payloadID - The location's payload id.
 * @param {String} requestID - The location's request id.
 * @param {String} rgAddressProvider - Reverse geocoding service provider - Esri, GIS, or Google.
 */
export const trackRGAddressProvider = ({
  irpVersion,
  payloadID,
  requestID,
  rgAddressProvider,
}) => {
  const rgAddressProviderName = getGeocoderName(rgAddressProvider);

  gspx.trackCustomEvent('GIS', {
    Category: 'GIS',
    irpVersion,
    'Launched date': new Date(),
    name: `${rgAddressProviderName} is utilized for reverse geocoding calls`,
    payloadID,
    requestID,
  });
};
